var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 0.5C9.57359 0.5 9.22788 0.845714 9.22788 1.27224V12.6424L6.58787 10.0024C6.28706 9.70163 5.79767 9.70163 5.49685 10.0024C5.19604 10.3033 5.19604 10.7927 5.49685 11.0935L9.45237 15.049C9.60053 15.1971 9.79808 15.2735 9.99563 15.2735C10.1932 15.2735 10.3907 15.1971 10.5389 15.049L14.4944 11.0935C14.7952 10.7927 14.7952 10.3033 14.4944 10.0024C14.1936 9.70163 13.7042 9.70163 13.4034 10.0024L10.7634 12.6424V1.26776C10.7679 0.841225 10.4267 0.5 10.0001 0.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7474 18.2322V13.7559C19.7474 13.3294 19.4017 12.9837 18.9751 12.9837C18.5486 12.9837 18.2029 13.3294 18.2029 13.7559V17.4645H1.79269V13.7559C1.79269 13.3294 1.44697 12.9837 1.02493 12.9837C0.60289 12.9837 0.252686 13.3294 0.252686 13.7559V18.2322C0.252686 18.6588 0.5984 19 1.02493 19H18.9751C19.4017 19 19.7474 18.6588 19.7474 18.2322Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.e07c6619af076c91f0cbe13fd53873d6.svg";
export { ForwardRef as ReactComponent };